module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalReveal', {
    ref: "terminateModal"
  }, [_c('button', {
    staticClass: "button",
    staticStyle: {
      "color": "#A3A3A3"
    },
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Terminate")]), _c('h2', [_vm._v("Terminate reservation R" + _vm._s(_vm.entity.number))]), _c('label', [_vm._v("Accept undesirable zone")]), _c('input-switch', {
    model: {
      value: (_vm.terminateBody.acceptUndesiderable),
      callback: function($$v) {
        _vm.$set(_vm.terminateBody, "acceptUndesiderable", $$v)
      },
      expression: "terminateBody.acceptUndesiderable"
    }
  }), (!_vm.configuration.constraints.constraints_forbid_to_end_in_forbidden.value) ? [_c('label', [_vm._v("Force forbidden zone")]), _c('input-switch', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.terminateBody.forceForbidden),
      callback: function($$v) {
        _vm.$set(_vm.terminateBody, "forceForbidden", $$v)
      },
      expression: "terminateBody.forceForbidden"
    }
  })] : _vm._e(), _c('ActionButton', {
    attrs: {
      "slot": "footer",
      "action": _vm.terminate
    },
    slot: "footer"
  }, [_vm._v("Terminate")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-38e25734!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/TerminateReservationReveal.vue
// module id = 2411
// module chunks = 1